import "./App.css";

import { BrowserRouter, Route, Routes } from "react-router-dom";
import Menu from "./components/navbar/Menu";
import Cover from "./components/cover/Cover";
import Footer from "./components/footer/Footer";
import Mailer from "./components/mailer/Mailer";
import Revista from "./components/revista/Revista";
import About from "./components/about/About";
import Portfolio from "./components/slider/Portfolio";
import CarouselComponent from './components/Carousel/CarouselComponent';
import ReferenciasComponent from "./components/ReferenciasComponent";
import PaymentMethodsComponent from "./components/PaymentMethodsComponent";
import Dashboard from "./components/Dashboard/Dashboard";
import CrearServicios from "./components/Dashboard/CrearServicios";
import Servicios from "./components/Dashboard/Servicios";
import Cotizador from "./components/FormInter/Cotizador";
import PromoComponent from "./components/promo/PromoComponent";
import Terminos from "./components/pages/Terminos";
import FAQ from "./components/pages/FAQ";
import PoliticaPrivacidad from "./components/pages/PoliticaPrivacidad"; // Importar pagina
import ScrollToTop from "./components/ScrollToTopButton";
import ScrollToRoute from "./components/ScrollToRoute"; // Importar el componente ScrollToRoute
const references = [
  {
    avatarUrl: "././img/imgC2.jfif",
    title: "Juan Alvarez",
    description: "Muy recomendable! en una semana tenia lista mi pagina web!"
  },
  {
    avatarUrl: "././img/imgC2.jfif",
    title: "Silvana Cuenca",
    description: "Antes no tenia presencia en línea, pero ahora estoy muy satisfecha con la calidad de su trabajo!"
  },
  {
    avatarUrl: "././img/imgC2.jfif",
    title: "Graciela  Moreno",
    description: "Muy buena atencion y relacion precio calidad!",

  },
  {
    avatarUrl: "././img/imgC2.jfif",
    title: "Pedro Sanchez",
    description: "Muy recomendable! ahora puedo vener y tomar pedido desde mi pagina web!"
  },
  {
    avatarUrl: "././img/imgC2.jfif",
    title: "Mario Caceres",
    description: " muy satisfecho con la calidad de su trabajo!"
  },
  {
    avatarUrl: "././img/imgC2.jfif",
    title: "Daniel Encina",
    description: "Muy buena calidad y precio economico!",

  }

];
const paymentMethods = [
  {
    name: "Tarjetas de crédito o débito",
    description: "Puede pagar con tarjeta de crédito o débito.",
    imageUrl: "././img/tarjetas.jfif",
  },
  {
    name: "Mercado Pago",
    imageUrl: "././img/mp.jfif",
    description: "Puede pagar con Mercado Pago con tarjetas o en efectivo."
  },
  {
    imageUrl: "././img/bancos.jfif",
    name: "Transferencia bancaria",
    description: "O puede realizar una transferencia bancaria por cbu o alias."
  }
];

const App = () => {
  return (
    <>
      <BrowserRouter>
        <ScrollToTop />
        <Menu />

        <Routes>

          <Route path='/' element={<Cover />} />
          <Route path='/Nosotros' element={<About />} />
          <Route path='/Trabajos' element={<Portfolio />} />
          <Route path='/promo' element={<PromoComponent />} />
          <Route path='/Contacto' element={<Mailer />} />
          <Route path='/Redes' element={<Footer />} />
          <Route path='/Dashboard' element={<Dashboard />} />
          <Route path='/Servicios' element={<Servicios />} />
          <Route path='/CrearServicios' element={<CrearServicios />} />
          <Route path='/Cotizador' element={<Cotizador />} />

          <Route path="/terminos-y-condiciones" element={<Terminos />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/politica-de-privacidad" element={<PoliticaPrivacidad />} />
        </Routes>


        <About />

        <Revista />
        <Portfolio />
        <PromoComponent />

        <CarouselComponent />

        <ReferenciasComponent references={references} />
        <PaymentMethodsComponent paymentMethods={paymentMethods} />
        <Mailer />

        <Footer />
        <ScrollToRoute />
      </BrowserRouter>
    </>
  );
}

export default App;
